<template>
  <DrawerInfo
    :title="videoCollectionInfo.title"
    :type="videoCollectionInfo.type"
    :author="videoCollectionImplementationData.author"
    :public-url="videoCollectionImplementationData.publicUrl"
    v-on="$listeners"
  />
</template>

<script>
import DrawerInfo from '@/scripts/pages/video/VideoCollectionDrawer/DrawerInfo';

export default {
  components: {
    DrawerInfo,
  },
  props: {
    videoCollectionInfo: {
      type: Object,
      required: true,
    },
    videoCollectionImplementationData: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      parentVideoCollectionInfo: {},
    };
  },
};
</script>
